import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import { ThemeProvider } from 'antd-style';
import enUS from 'antd/locale/en_US';
import dayjs from 'dayjs';
import { Toaster } from 'react-hot-toast';
import { useRoutes } from 'react-router-dom';

import { ErrorBoundary, ThemeModeContext, useThemeMode } from '@herond/shared';
import { customToken, darkTheme, lightTheme } from '@herond/shared/styles';

import hostUIRoutes from './routes';
import './style.css';

dayjs.locale('en');

const queryClient = new QueryClient();

const App = () => {
  const routes = useRoutes(hostUIRoutes);
  const { mode, setMode, colorScheme } = useThemeMode();
  const activeTheme = colorScheme === 'dark' ? darkTheme : lightTheme;

  return (
    <ThemeModeContext.Provider value={{ mode, setMode, colorScheme }}>
      <ErrorBoundary>
        <ThemeProvider theme={activeTheme} customToken={customToken} appearance={colorScheme}>
          <ConfigProvider theme={activeTheme} locale={enUS}>
            <QueryClientProvider client={queryClient}>
              {routes}
              <Toaster />
            </QueryClientProvider>
          </ConfigProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </ThemeModeContext.Provider>
  );
};

export default App;
